import { render, staticRenderFns } from "./AssetViewer.vue?vue&type=template&id=59f41c52&scoped=true"
import script from "./AssetViewer.vue?vue&type=script&lang=ts"
export * from "./AssetViewer.vue?vue&type=script&lang=ts"
import style0 from "./AssetViewer.vue?vue&type=style&index=0&id=59f41c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f41c52",
  null
  
)

export default component.exports